import { connect } from 'react-redux';
import XapInterstitial from '../components/XapInterstitial';
import { xapDismissed } from '../helpers/xap';
import { flagEnabled, isReady } from '../helpers/featureFlags';


const mapStateToProps = ({
  account: {
    data: {
      xap,
      services: {
        internet: { subscribed: internet } = {},
      } = {},
    } = {},
  },
  auth: {
    macaroon: {
      mainAccountRoles = [],
    } = {},
  } = {},
  harness: { isHarness } = {},
}) => {
  const dismissed = xapDismissed();

  const hasBilling = mainAccountRoles && (
    mainAccountRoles.indexOf('PRIMARY') !== -1
    || mainAccountRoles.indexOf('BILLPAY') !== -1
  );
  const xapOk = (
    xap
    && typeof xap === 'object'
    && xap.status
    && xap.state === 'XAP_CURRENT'
  );
  const eligible = (
    isReady() && flagEnabled('xapInterstitial')
    && !isHarness
    && hasBilling
    && xapOk
    && internet
  );

  return {
    eligible,
    dismissed,
  };
};

export default connect(mapStateToProps, null)(XapInterstitial);
